var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('answer-header',{attrs:{"type":"back"}}),_vm._v(" "),_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo.png")}}),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"item"},[_c('h2',[_vm._v(_vm._s(item.id)+": ")]),_vm._v(" "),_c('p',{staticClass:"questContainer"},[_vm._v(_vm._s(item.info))])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b79abe76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Docinfo.vue
// module id = null
// module chunks = 